module.exports = __webpack_public_path__ + "img/lucky-draw-bg.13491ea.png";